<template>
  <div class="count">
    <DpplTooltip
      v-if="useTooltip"
      tooltip-placement="left"
      :tooltip-offset="12"
    >
      <template #activator="{ onMouseenter, onMouseleave }">
        <div
          class="total-count"
          @mouseenter="onMouseenter"
          @mouseleave="onMouseleave"
        >
          {{ total }}
        </div>
      </template>
      <template #tooltip-content>
        <div class="d-flex flex-column align-start justify-content-start ga-2">
          <p
            v-for="(value, key) in tooltipValues"
            :key="key"
            :class="key.toLowerCase()"
            class="label-value"
          >
            {{ key }}: {{ value }}
          </p>
        </div>
      </template>
    </DpplTooltip>
    <div v-else class="total-count">
      {{ totalFormatted }}
    </div>
  </div>
</template>

<script setup>
import { isEmpty } from 'lodash-es';
import { computed } from 'vue';
import { numberWithCommas } from '@/helpers/formatters';
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';

const props = defineProps({
  total: {
    type: [Number, String],
    required: true,
  },
  tooltipValues: {
    type: Object,
    default: () => ({}),
  },
});

const useTooltip = computed(() => !isEmpty(props.tooltipValues));
const totalFormatted = computed(() => numberWithCommas(props.total));
</script>

<style lang="less" scoped>
.total-count {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: @text-brand;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
}

.count :deep(span) {
    width: 100%;
    height: 100%;
}

.label-value {
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  color: @text-light;
}

.draft {
  color: @text-brand;
}

.published {
  color: @brand-primary;
}

.unpublished {
  color: @basic-orange;
}

.application {
  color: @text-brand;
}

.screening {
  color: @basic-pink;
}

.assessment {
  color: @basic-orange;
}

.offer {
  color: @basic-green;
}
</style>
